module.exports = __webpack_public_path__ + "img/metered.acecf3d1.svg";